/**
 * AnchorScroll
 *
 * @version 1.0.0
 * @copyright 2019 SEDA.digital GmbH & Co. KG
 */

// NOTE: When importing modules from npm, make sure to check if they use ES6 syntax or not.
// If so, add them to the include regex for babel-loader in webpack.config.js
import ClassLogger from 'ClassLogger';
// to import legacy 3rd party scripts (into the global space) use the script-loader like this:
// import legacyScript from 'script-loader!../../vendor/legacy/script.js';

class AnchorScroll {
    getClassName() { return 'AnchorScroll'; }
    constructor() {
        let self = this;
        self.logger = ClassLogger(self, false); // set second parameter to false to disable logging

        if ($('[data-anchor-scroll]').length === 0) return;
        self.init();
    }

    init() {
        let self = this;
        self.logger.log('AnchorScroll function is running...'); // also supports .warn() and .error()

        $('[data-anchor-scroll]').each(function (index, item) {
            $(item).on('click', function (e) {
                const href = $(item).attr('href');
                if (href.charAt(0) === '#' && href.length > 1) {
                    e.preventDefault();
                    $('html, body').animate({
                        scrollTop: ($(href).offset().top - 13)
                    }, 1000);
                }

            })
        })

    }
}

export default new AnchorScroll();
